import script from "./topBack.vue?vue&type=script&setup=true&name=topBack&lang=js"
export * from "./topBack.vue?vue&type=script&setup=true&name=topBack&lang=js"

import "./topBack.vue?vue&type=style&index=0&id=7f1475fe&scoped=true&lang=css"

import exportComponent from "D:\\Jawsro\\company\\虎鲸\\v3\\hujing_pro_h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f1475fe"]])

export default __exports__